// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload[data-v-0c674c54] {\n  display: flex;\n}\n.upload[data-v-0c674c54]  .el-upload {\n  order: 2;\n}\n.upload[data-v-0c674c54]  .el-upload-list {\n  order: 1;\n  width: calc(100% - 1em - 72px);\n  margin-right: 1em;\n  background-color: #F5F7FA;\n  border-radius: 4px;\n  border: 1px solid #DCDFE6;\n}\n.upload[data-v-0c674c54]  .el-upload-list .el-upload-list__item {\n  margin-top: 7px;\n}", ""]);
// Exports
module.exports = exports;
